import Navigation from '../navigation/Navigation';

const NavigationBlock = ({ content }) => {
  return content ? <Navigation navigation={content} /> : null;
};
export default NavigationBlock;
